<template>
  <div>
    <download-excel
      ref="excelExport"
      style="display: none;"
      :fields="json_fields"
      :fetch="startDownload"
      type="xls"
      name="合作商家订单表.xls"
    >
    </download-excel>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="handleExport">
      Excel导出
    </a-button>
    <span style="margin-left: 20px;">
      当前金额合计：{{ sumAmount }} ， 当前彩票合计：{{ sumTickets }}
    </span>
     <a-table 
      :columns="columns" 
      :data-source="data" 
      :loading="loading"
      :pagination="pagination"
      :row-key="(record) => record.objId"
      @change="handleTableChange">


  </a-table>
  </div>
</template>
<script>
import { storeGetNearbyShopOrderList,storeGetNearbyShopOrderInfo,storeGetNearbyShopOrderCount } from "@/api/storeApi.js";
import { exchangeOk, exchangeNo } from "@/api/homeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "订单编号",
    dataIndex: "orderNo",
    align: "center",
    key: "1",
    width:220,
  },
  {
    title: "商家名称",
    dataIndex: "partnerName",
    align: "center",
    key: "2",
  
  },

  {
    title: "商品金额",
    dataIndex: "amount",
    align: "center",
    key: "3",

  },
    {
    title: "彩票数量",
    dataIndex: "tickets",
    key: "4",
    align: "center",
  },
  {
    title: "卡号",
    dataIndex: "cardNo",
    align: "center",
    key: "5",
    width:100,

  },

  {
    title: "订单时间",
    dataIndex: "createTime",
    align: "center",
    key: "6",

  },

];


export default {
  data() {
    return {
      data: [],
      json_fields: {
        订单号: "orderNo",
        卡号: "cardNo",
        商家名称: "partnerName",
        商品金额:"amount",
        彩票数量: "tickets",
        订单时间: "createTime",
        
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      localFormInline: {} ,// 新增：用于存储 formInline 的本地副本
      sumAmount: 0,
      sumTickets: 0,
    };
  },
  mounted() {
    // 刚点开的时候自动加载全部数据
    this.getOrderList();
  },
  props: ["formInline"],
  watch: {
    // 监听 formInline 变化并更新本地副本
    formInline: {
      handler(newVal) {
        this.localFormInline = { ...newVal };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    // 处理导出
    handleExport() {
      this.$refs.excelExport.click();
    },
    // 查询
    search() {
     
      // 创建一个新的对象，清空 createTime 字段
      const queryParams = {
        ...this.localFormInline,
        createTime: null
      };
      // console.log('数据:', queryParams);
      
      this.data = [];
      this.loading = true;
      // 确保分页参数也被传递
      this.pagination.current = 1;   // 重置当前页
 
      storeGetNearbyShopOrderInfo(queryParams).then((res) => {
        // console.log('请求成功，返回数据:', res);
        this.loading = false;
        if(res.data.data !=null){
          this.data = res.data.data;
          this.getCount(res.data.data);
        }else{
          message.error('暂无数据');
          this.sumAmount = 0;
          this.sumTickets = 0;
        }
        
        this.pagination.total = Number(res.data.count);
        
      }).catch((error) => {
        this.loading = false;
        console.error('请求出错:', error);
        message.error('error', error);
      });
    },
      // 添加这个方法用于导出所有数据
    async startDownload() {
      try {
        // 调用API获取所有数据，不分页
        const res = await storeGetNearbyShopOrderList({
          page: 1,
          limit: 10000 // 设置一个足够大的数值来获取所有数据
        });
        
        if (res.data.data != null) {
          // 返回所有数据用于导出
          return res.data.data;
        } else {
          message.error('暂无数据可导出');
          return [];
        }
      } catch (error) {
        message.error('导出失败: ' + error.message);
        return [];
      }
    },
    // 分页按钮配置
    handleTableChange(pagination, filters, sorter) {
      console.log('分页变化:', pagination);
      this.pagination.current = pagination.current; //重置当前页
      this.pagination.pageSize = pagination.pageSize; //重置每页条数
      this.search(); //重新查询
    },

    // 获取合计
    getCount(row){
      this.sumAmount = 0;
      this.sumTickets = 0;
      if(row != null){
        this.sumAmount = row[0].sumAmount,
        this.sumTickets = row[0].sumTickets
      }
    },
 
    // 分页数据
    getOrderList() {
      this.data = [];
      // 重置分页参数并查询第一页
      this.pagination.current = 1;
    
      storeGetNearbyShopOrderList(this.pagination.current,this.pagination.pageSize).then((res) => {
        console.log('请求成功，返回数据:', res);
        this.pagination.total = Number(res.data.count);
        if(res.data.data !=null){
          this.data = res.data.data;
          this.getCount(res.data.data);
        }else{
          message.error('暂无数据');
          this.sumAmount = 0;
          this.sumTickets = 0;
        }

      }).catch((error) => {
        console.error('请求出错:', error);
      });
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },

   

  },
};
</script>
<style scoped>
.test {
  position: relative;
  left: 55px;
}

#components-table-demo-summary tfoot th,
#components-table-demo-summary tfoot td {
  background: #fafafa;
}
[data-theme='dark'] #components-table-demo-summary tfoot th,
[data-theme='dark'] #components-table-demo-summary tfoot td {
  background: #1d1d1d;
}
</style>


// WEBPACK FOOTER //
// src/views/orderManagement/partnerOrderTwo/partnerOrderContentTwo.vue